// Book cover images
import agam02Sutrakrutang from "@jambushrushti/assets/books/agam-02-sutrakrutang.png";
import agam03Sthananga01 from "@jambushrushti/assets/books/agam-03-sthananga-new.png";
import agam03Sthananga02 from "@jambushrushti/assets/books/agam-03-sthananga-02.png";
import agam03Sthananga03 from "@jambushrushti/assets/books/agam-03-sthananga-03.png";
import agam06Gnatadharma from "@jambushrushti/assets/books/agam-06-gnatadharma.png";
import agam45Anuyogdwar from "@jambushrushti/assets/books/agam-45-anuyogdwar.png";
import dwadashanramPart1 from "@jambushrushti/assets/books/dwadashanram-part1.png";
import dwadashanramPart2 from "@jambushrushti/assets/books/dwadashanram-part2.png";
import dwadashanramPart3 from "@jambushrushti/assets/books/dwadashanram-part3.png";
import guruvani1 from "@jambushrushti/assets/books/guruvani-1.jpg";
import guruvani2 from "@jambushrushti/assets/books/guruvani-2.jpg";
import guruvani3 from "@jambushrushti/assets/books/guruvani-3.jpg";
import gurubhaktiGahuli from "@jambushrushti/assets/books/gurubhakti-gahuli.jpg";
import dashvaikalikSutra from "@jambushrushti/assets/books/dashvaikalik-sutra.jpg";
import hemchandraShabdanushasanam from "@jambushrushti/assets/books/hemchandra-shabdanushasanam.jpg";
import hastlikhitGranthsuchi1 from "@jambushrushti/assets/books/hastlikhit-granthsuchi-1.jpg";
import hastlikhitGranthsuchi2 from "@jambushrushti/assets/books/hastlikhit-granthsuchi-2.jpg";

export interface CatalogItem {
  id: number;
  type: "Book" | "Manuscript";
  title: string;
  author: string;
  year: string;
  language: string;
  category: string;
  available: boolean;
  location: string;
  description: string;
  publisher: string;
  pages: number;
  image: string;
  // Manuscript specific fields
  granthName?: string;
  hastrapNo?: string;
  mulkarta?: string;
  tikakarta?: string;
  folioNo?: string;
  totalPages?: number;
  availablePages?: number;
}

export const catalogItems: CatalogItem[] = [
  // BOOKS
  {
    id: 1,
    type: "Book",
    title: "Agam 02 Ang 02 Sutrakrutang Sutra",
    author: "Muni Jambuvijayji",
    year: "2022",
    language: "Sanskrit",
    category: "Agama Studies",
    available: true,
    location: "Rack A-12",
    description:
      "The second Agama of the Jain canon, Sutrakrutang Sutra, contains profound teachings on the path to liberation. This comprehensive edition presents the original Prakrit text with Sanskrit commentary.",
    publisher: "Shri Mahavira Jaina Vidyalaya",
    pages: 450,
    image: agam02Sutrakrutang,
  },
  {
    id: 2,
    type: "Book",
    title: "Agam 03 Ang 03 Sthananga Sutra Part 01",
    author: "Muni Jambuvijayji",
    year: "2022",
    language: "Sanskrit",
    category: "Agama Studies",
    available: true,
    location: "Rack A-13",
    description:
      "The Sthananga Sutra is a canonical Jain text that systematically categorizes various concepts. Part 01 covers the foundational classifications used in Jain philosophy and practice.",
    publisher: "Shri Mahavira Jaina Vidyalaya",
    pages: 380,
    image: agam03Sthananga01,
  },
  {
    id: 3,
    type: "Book",
    title: "Agam 03 Ang 03 Sthananga Sutra Part 02",
    author: "Muni Jambuvijayji",
    year: "2022",
    language: "Sanskrit",
    category: "Agama Studies",
    available: true,
    location: "Rack A-14",
    description:
      "Continuation of the Sthananga Sutra. Part 02 expands on the numerical classifications of Jain philosophical concepts.",
    publisher: "Shri Mahavira Jaina Vidyalaya",
    pages: 420,
    image: agam03Sthananga02,
  },
  {
    id: 4,
    type: "Book",
    title: "Agam 03 Ang 03 Sthananga Sutra Part 03",
    author: "Muni Jambuvijayji",
    year: "2022",
    language: "Sanskrit",
    category: "Agama Studies",
    available: true,
    location: "Rack A-15",
    description:
      "The concluding part of Sthananga Sutra, completing the comprehensive study of Jain categorical philosophy.",
    publisher: "Shri Mahavira Jaina Vidyalaya",
    pages: 390,
    image: agam03Sthananga03,
  },
  {
    id: 5,
    type: "Book",
    title: "Agam 06 Ang 06 Gnatadharma Sutra",
    author: "Muni Jambuvijayji",
    year: "2022",
    language: "Sanskrit",
    category: "Agama Studies",
    available: true,
    location: "Rack A-16",
    description:
      "The Gnatadharma Sutra (Nayadhammakahao) is the sixth Anga containing stories and teachings illustrating Jain ethical principles through narratives.",
    publisher: "Shri Mahavira Jaina Vidyalaya",
    pages: 520,
    image: agam06Gnatadharma,
  },
  {
    id: 6,
    type: "Book",
    title: "Agam 45 Chulika 02 Anuyogdwar Sutra",
    author: "Muni Jambuvijayji",
    year: "2022",
    language: "Sanskrit",
    category: "Agama Studies",
    available: true,
    location: "Rack A-17",
    description:
      "The Anuyogdwar Sutra provides methodology for understanding and interpreting Jain scriptures with guidelines for proper textual analysis.",
    publisher: "Shri Mahavira Jaina Vidyalaya",
    pages: 290,
    image: agam45Anuyogdwar,
  },
  {
    id: 7,
    type: "Book",
    title: "Dvadasharam Naychakram Part 1 Tika",
    author: "Muni Jambuvijayji",
    year: "2020",
    language: "Sanskrit",
    category: "Philosophy",
    available: true,
    location: "Rack B-01",
    description:
      "Part one of the comprehensive Dvadasharam Naychakram with detailed Tika (commentary) on Jain logic and epistemology.",
    publisher: "Shri Mahavira Jaina Vidyalaya",
    pages: 350,
    image: dwadashanramPart1,
  },
  {
    id: 8,
    type: "Book",
    title: "Dvadasharam Naychakram Part 2 Tika",
    author: "Muni Jambuvijayji",
    year: "2020",
    language: "Sanskrit",
    category: "Philosophy",
    available: true,
    location: "Rack B-02",
    description:
      "Continuation of Dvadasharam Naychakram Tika, furthering the exposition of Jain logical principles.",
    publisher: "Shri Mahavira Jaina Vidyalaya",
    pages: 320,
    image: dwadashanramPart2,
  },
  {
    id: 9,
    type: "Book",
    title: "Dvadasharam Naychakram Part 3 Tika",
    author: "Muni Jambuvijayji",
    year: "2020",
    language: "Sanskrit",
    category: "Philosophy",
    available: true,
    location: "Rack B-03",
    description:
      "The concluding part of Dvadasharam Naychakram Tika, completing the study of Jain logical philosophy.",
    publisher: "Shri Mahavira Jaina Vidyalaya",
    pages: 340,
    image: dwadashanramPart3,
  },
  {
    id: 10,
    type: "Book",
    title: "Guruvani 1",
    author: "Muni Jambuvijayji",
    year: "2018",
    language: "Gujarati",
    category: "Guruvani",
    available: true,
    location: "Rack C-01",
    description:
      "The first volume of Guruvani, a collection of spiritual discourses and teachings by Gurudev Muni Jambuvijayji.",
    publisher: "Siddhi Jambu Parivar",
    pages: 280,
    image: guruvani1,
  },
  {
    id: 11,
    type: "Book",
    title: "Guruvani 2",
    author: "Muni Jambuvijayji",
    year: "2019",
    language: "Gujarati",
    category: "Guruvani",
    available: true,
    location: "Rack C-02",
    description:
      "The second volume of Guruvani, continuing the collection of Gurudev's profound spiritual teachings.",
    publisher: "Siddhi Jambu Parivar",
    pages: 310,
    image: guruvani2,
  },
  {
    id: 12,
    type: "Book",
    title: "Guruvani 3",
    author: "Muni Jambuvijayji",
    year: "2020",
    language: "Gujarati",
    category: "Guruvani",
    available: true,
    location: "Rack C-03",
    description:
      "The third volume of Guruvani with more spiritual wisdom and guidance from Gurudev Muni Jambuvijayji.",
    publisher: "Siddhi Jambu Parivar",
    pages: 295,
    image: guruvani3,
  },
  {
    id: 13,
    type: "Book",
    title: "Gurubhakti Gahuli Sangrah",
    author: "Muni Jambuvijayji",
    year: "2015",
    language: "Gujarati",
    category: "Devotional",
    available: true,
    location: "Rack C-04",
    description:
      "A collection of devotional verses (Gahuli) expressing reverence and devotion to the Guru tradition in Jainism.",
    publisher: "Siddhi Jambu Parivar",
    pages: 180,
    image: gurubhaktiGahuli,
  },
  {
    id: 14,
    type: "Book",
    title: "Dashvaikalik Sutra Vrutti Ane Dinag",
    author: "Muni Jambuvijayji",
    year: "2019",
    language: "Sanskrit",
    category: "Agama Studies",
    available: true,
    location: "Rack A-20",
    description:
      "Commentary on the Dashvaikalik Sutra, one of the important Jain canonical texts containing rules for monks.",
    publisher: "Shri Mahavira Jaina Vidyalaya",
    pages: 420,
    image: dashvaikalikSutra,
  },
  {
    id: 15,
    type: "Book",
    title: "Hemchandrashabdanushasanam",
    author: "Acharya Hemchandra",
    year: "2018",
    language: "Sanskrit",
    category: "Grammar",
    available: true,
    location: "Rack D-01",
    description:
      "The monumental Sanskrit grammar treatise by Acharya Hemchandra, a foundational text for Sanskrit and Prakrit linguistics.",
    publisher: "Shri Mahavira Jaina Vidyalaya",
    pages: 650,
    image: hemchandraShabdanushasanam,
  },
  // MANUSCRIPTS
  {
    id: 16,
    type: "Manuscript",
    title: "Hastlikhit Granthsuchi Part 1",
    author: "Traditional",
    year: "19th Century",
    language: "Sanskrit",
    category: "Catalog",
    available: false,
    location: "Special Collection",
    description:
      "A handwritten catalog of manuscripts in the collection, documenting rare Jain texts and their locations.",
    publisher: "Traditional Manuscript",
    pages: 200,
    image: hastlikhitGranthsuchi1,
    granthName: "Hastlikhit Granthsuchi",
    hastrapNo: "MS-001",
    mulkarta: "Unknown",
    folioNo: "1-100",
    totalPages: 200,
    availablePages: 200,
  },
  {
    id: 17,
    type: "Manuscript",
    title: "Hastlikhit Granthsuchi Part 2",
    author: "Traditional",
    year: "19th Century",
    language: "Sanskrit",
    category: "Catalog",
    available: false,
    location: "Special Collection",
    description:
      "Continuation of the handwritten manuscript catalog, documenting additional rare texts in the collection.",
    publisher: "Traditional Manuscript",
    pages: 180,
    image: hastlikhitGranthsuchi2,
    granthName: "Hastlikhit Granthsuchi",
    hastrapNo: "MS-002",
    mulkarta: "Unknown",
    folioNo: "101-190",
    totalPages: 180,
    availablePages: 175,
  },
  {
    id: 18,
    type: "Manuscript",
    title: "Kalpasutra (Illustrated)",
    author: "Traditional",
    year: "15th Century",
    language: "Prakrit",
    category: "Scripture",
    available: false,
    location: "Special Collection",
    description:
      "An exquisitely illustrated manuscript of the Kalpasutra, one of the most important Jain texts with traditional miniature paintings.",
    publisher: "Traditional Manuscript",
    pages: 120,
    image: guruvani1, // Placeholder
    granthName: "Shri Kalpasutra",
    hastrapNo: "MS-003",
    mulkarta: "Bhadrabahu Swami",
    folioNo: "1-60",
    totalPages: 120,
    availablePages: 118,
  },
  {
    id: 19,
    type: "Manuscript",
    title: "Bhaktamara Stotra",
    author: "Acharya Manatunga",
    year: "8th Century",
    language: "Sanskrit",
    category: "Devotional",
    available: false,
    location: "Special Collection",
    description:
      "A rare manuscript of the beloved devotional hymn composed by Acharya Manatunga, consisting of 48 powerful verses.",
    publisher: "Traditional Manuscript",
    pages: 28,
    image: gurubhaktiGahuli, // Placeholder
    granthName: "Bhaktamara Stotra",
    hastrapNo: "MS-004",
    mulkarta: "Acharya Manatunga",
    folioNo: "1-14",
    totalPages: 28,
    availablePages: 28,
  },
  {
    id: 20,
    type: "Manuscript",
    title: "Tattvartha Sutra (Palm Leaf)",
    author: "Umaswati",
    year: "12th Century",
    language: "Sanskrit",
    category: "Philosophy",
    available: false,
    location: "Special Collection",
    description:
      "A rare palm leaf manuscript of the foundational Jain philosophical text presenting the seven tattvas (realities).",
    publisher: "Traditional Manuscript",
    pages: 85,
    image: hemchandraShabdanushasanam, // Placeholder
    granthName: "Tattvartha Sutra",
    hastrapNo: "MS-005",
    mulkarta: "Umaswati",
    tikakarta: "Siddhasena Gani",
    folioNo: "1-43",
    totalPages: 85,
    availablePages: 82,
  },
];
